import styled from 'styled-components'
import colors from '../../../configuration/colors'

export default styled.button`
  width: max-content;
  height: 32px;
  padding: 0 20px;
  cursor: pointer;
  border: 1px solid ${colors.aluminum};
  background: transparent;
  border-radius: 100px;
  color: ${colors.black};
  font-size: 16px;
  font-weight: 500;
`
